

export default ({ categoriesForField, contactForm, children }) => {
  const selectedCategory = contactForm && contactForm.values && contactForm.values.contactCategory
  return (
    categoriesForField.map(item => item === parseInt(selectedCategory) ? children : null )
  )
}



// WEBPACK FOOTER //
// ./components/Contact/ContactFieldOptions.js